import { fb, validators, formModelHelper } from '../../../lib/form';

const hearAboutUsOptions = [
  { name: 'How did you hear about us?*', value: '' },
  ...['Google', 'Instagram', 'Facebook', 'Referral'].map(x => { return { name: x, value: x } }),
  { name: 'Other (please specify)', value: 'Other' }
];

// 'Other' reveals the extra text field, which is only validated while 'Other' is selected.
function onHearAboutUsChanged(control, formModel) {
  const other = formModelHelper.findControl('hearAboutUsOther', formModel);
  if (!other) return;

  const isOther = control.value === 'Other';
  other.disableValidators = !isOther;
  if (!isOther) {
    other.value = '';
    other.errors = [];
  }
}

export function getContactModel(data) {
  const model = fb.group({
    name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
    hearAboutUs: [data.hearAboutUs || '', [validators.Required('Please tell us how you heard about us.')], { label: null, type: 'select', options: hearAboutUsOptions, onBeforeUpdateValue: onHearAboutUsChanged }],
    hearAboutUsOther: [data.hearAboutUsOther || '', [validators.Required('Please specify how you heard about us.')], { label: 'Please specify', type: 'text', disableValidators: !data.hearAboutUsOther }],
    enquiry: [data.enquiry || '', [validators.Required()], { label: 'Your Message', type: 'textarea' }],
    attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }]
  });
  return model;
}
